import { CaseloadHistoryCard } from 'Components/Cards/CaseloadHistoryCard/CaseloadHistoryCard'

export default CaseloadHistoryCard
